import { useMutation } from '@tanstack/react-query'
import { t } from 'i18next'

import type { TCriarPropostaResponse, TPropostaData } from '@/features/proposta/interfaces/proposta.type'
import { CriarProposta } from '@/features/proposta/services/criar-proposta.service'
import type { AxiosErrorMap } from '@/shared/lib/http/axios-adapter'
import { showToast } from '@/shared/lib/sonner'

const PRODUTO_INDISPONIVEL = 'PRODUCT_UNAVAILABLE'
const VAGA_PADRAO_INDISPONIVEL = 'STANDARD_PARKING_UNAVAILABLE'

export const useCriarProposta = () => {
  return useMutation<TCriarPropostaResponse, AxiosErrorMap, TPropostaData>({
    mutationFn: (proposta: TPropostaData) => new CriarProposta().execute(proposta),
    onSuccess: () => {
      showToast({
        message: t('proposta:resumo_proposta.modal_envio.sucesso'),
        variant: 'success',
      })
    },
    onError: (error) => {
      const erroProdutoIndisponivel = error?.response?.data?.find((e) => e.code === PRODUTO_INDISPONIVEL)
      const erroVagaPadraoIndisponivel = error?.response?.data?.find((e) => e.code === VAGA_PADRAO_INDISPONIVEL)
      if (erroProdutoIndisponivel) {
        const regexParaCodigoProduto = /\[([^\]\r\n]{1,25})]/ // NOSONAR
        const codigoProduto = regexParaCodigoProduto.exec(erroProdutoIndisponivel.message)?.[1]
        showToast({
          message: t('proposta:resumo_proposta.modal_envio.erro_produto_indisponivel', { code: codigoProduto ?? '' }),
          variant: 'error',
        })
        return
      }

      if (erroVagaPadraoIndisponivel) {
        showToast({
          message: t('proposta:resumo_proposta.modal_envio.erro_vaga_padrao_indisponivel'),
          variant: 'error',
        })
        return
      }

      showToast({
        message: t('common:errors_gerais.padrao'),
        variant: 'error',
      })
    },
  })
}
